export default "__VITE_ASSET__BrpnnUGU__"